import { and, count, eq, type PowerSyncDrizzleDB, time_entry } from "@time-tracker/powersync";
import { liveTimeEntryFilters } from "./filters";

/**
 * Counts LIVE time entries of a visitor in local SQLite.
 * Powers `checkUnsyncedActor` (prompt "Keep local data?" when migrating
 * from guest to real account): previously did raw `count() from(time_entry)` in
 * `auth/controllers.ts`, also counting entries already in the trash
 * (scattered invariant bug — a deleted entry still triggered the
 * prompt "you have local data" even if nothing live remained to keep).
 * Via the live layer it only counts live entries (and excludes those in a
 * trashed project/task, per `liveTimeEntryFilters` cohort).
 */
export function getLiveTimeEntryCountForUserQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({ total: count() })
    .from(time_entry)
    .where(and(eq(time_entry.user_id, userId), ...liveTimeEntryFilters()));
}
